import { render, staticRenderFns } from "./AppointmentHxTable.vue?vue&type=template&id=b0ca79fa&scoped=true"
import script from "./AppointmentHxTable.vue?vue&type=script&lang=js"
export * from "./AppointmentHxTable.vue?vue&type=script&lang=js"
import style0 from "./AppointmentHxTable.vue?vue&type=style&index=0&id=b0ca79fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ca79fa",
  null
  
)

export default component.exports